import { useQuery } from 'react-query';
import { AxiosResponse } from 'axios';
import apiClient from '../apiClient/apiClient';
import { TimeRecord } from './time.type';

export const useTimes = (enabled: boolean = false) => {
  return useQuery<AxiosResponse<TimeRecord[]>>({
    queryKey: 'times',
    queryFn: () => apiClient.get<TimeRecord[]>('/times'),
    enabled,
  });
};